import { Benifit } from "@/models/ICommon"
import stores from "@/stores"

import { getBenefitInfo } from "./content/roles"
import { showUpgradeModal } from "./showUpgradeModal"

export function showUpgradeModalByBenefits(props: { benefits: Benifit }) {
  const { benefits } = props
  const { kind, hasBenefits } = getBenefitInfo(benefits)

  if (hasBenefits) return
  const user_pkg = stores.PlanStore.config?.user_pkg
  const isReturnProtection = benefits === "free_return_service"
  // 如果是bundle套餐
  if (user_pkg?.source === 3) {
    stores.PlanStore.setAppType("bundle")
    stores.PlanStore.setPerferKind(kind)
    pnav("/billing", {
      tab: "bundle",
      kind,
    })
    return
  }
  // 如果是运费险
  if (isReturnProtection) {
    //  1. 如果用户是年费，显示upgrade to Essential-monthly
    //  2. 如果用户是（free套餐），显示upgrade to Essential - monthly
    if (
      !user_pkg ||
      user_pkg?.package_kind < 2 ||
      user_pkg.package_period === 2
    ) {
      // 打开订阅弹窗
      showUpgradeModal({
        type: 1,
        package_kind: Math.max(2, user_pkg?.package_kind ?? 0),
        feature: benefits,
      })
      return
    }
  }
  // 如果是一些需要弹窗展示的
  showUpgradeModal({
    type: 1,
    package_kind: kind,
    feature: benefits,
  })

  window.track("upgrade_popup_show", {
    source: benefits,
  })
  const map2 = {
    "2": "essential",
    "3": "professional",
    "4": "enterprise",
  }
  window.cwreport?.report("click_upgrade", {
    plan_version: map2[kind] ?? "essential",
    upgrade_position: benefits ?? "",
  })
}
